var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "orderProcessCol" },
    [
      _c("div", { staticClass: "orderProcessCol__top" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "bcWhite box-shadow" },
            [
              _c(
                "el-tabs",
                {
                  staticClass: "bcWhite",
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleTabClick },
                  model: {
                    value: _vm.queryParams.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "status", $$v)
                    },
                    expression: "queryParams.status",
                  },
                },
                [
                  _c("el-tab-pane", { attrs: { label: "新订单", name: "1" } }, [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(" 新订单"),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.countOrderMap[1] &&
                                _vm.countOrderMap[1] > 0,
                              expression:
                                "countOrderMap[1] && countOrderMap[1] > 0",
                            },
                          ],
                          staticClass: "el-badge__content",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm._f("dot")(_vm.countOrderMap[1])) + " "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "异常订单", name: "2" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(" 异常订单"),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.countOrderMap[2] &&
                                  _vm.countOrderMap[2] > 0,
                                expression:
                                  "countOrderMap[2] && countOrderMap[2] > 0",
                              },
                            ],
                            staticClass: "el-badge__content",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm._f("dot")(_vm.countOrderMap[2])) + " "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _c("el-tab-pane", { attrs: { label: "催单", name: "3" } }, [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(" 催单"),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.countOrderMap[3] &&
                                _vm.countOrderMap[3] > 0,
                              expression:
                                "countOrderMap[3] && countOrderMap[3] > 0",
                            },
                          ],
                          staticClass: "el-badge__content",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm._f("dot")(_vm.countOrderMap[3])) + " "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "配送异常", name: "4" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(" 配送异常"),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.countOrderMap[4] &&
                                  _vm.countOrderMap[4] > 0,
                                expression:
                                  "countOrderMap[4] && countOrderMap[4] > 0",
                              },
                            ],
                            staticClass: "el-badge__content",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm._f("dot")(_vm.countOrderMap[4])) + " "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "取消/退款", name: "5" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(" 申请退款"),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.countOrderMap[5] &&
                                  _vm.countOrderMap[5] > 0,
                                expression:
                                  "countOrderMap[5] && countOrderMap[5] > 0",
                              },
                            ],
                            staticClass: "el-badge__content",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm._f("dot")(_vm.countOrderMap[5])) + " "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _c("el-tab-pane", { attrs: { label: "预订单", name: "6" } }, [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(" 预订单"),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.countOrderMap[6] &&
                                _vm.countOrderMap[6] > 0,
                              expression:
                                "countOrderMap[6] && countOrderMap[6] > 0",
                            },
                          ],
                          staticClass: "el-badge__content",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm._f("dot")(_vm.countOrderMap[6])) + " "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c("el-tab-pane", { attrs: { label: "待抢单", name: "7" } }, [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(" 待抢单"),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.countOrderMap[7] &&
                                _vm.countOrderMap[7] > 0,
                              expression:
                                "countOrderMap[7] && countOrderMap[7] > 0",
                            },
                          ],
                          staticClass: "el-badge__content",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm._f("dot")(_vm.countOrderMap[7])) + " "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c("el-tab-pane", { attrs: { label: "待取货", name: "8" } }, [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(" 待取货"),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.countOrderMap[8] &&
                                _vm.countOrderMap[8] > 0,
                              expression:
                                "countOrderMap[8] && countOrderMap[8] > 0",
                            },
                          ],
                          staticClass: "el-badge__content",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm._f("dot")(_vm.countOrderMap[8])) + " "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c("el-tab-pane", { attrs: { label: "配送中", name: "9" } }, [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(" 配送中"),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.countOrderMap[9] &&
                                _vm.countOrderMap[9] > 0,
                              expression:
                                "countOrderMap[9] && countOrderMap[9] > 0",
                            },
                          ],
                          staticClass: "el-badge__content",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm._f("dot")(_vm.countOrderMap[9])) + " "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "待处理", name: "10" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(" 待处理"),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.countOrderMap[10] &&
                                  _vm.countOrderMap[10] > 0,
                                expression:
                                  "countOrderMap[10] && countOrderMap[10] > 0",
                              },
                            ],
                            staticClass: "el-badge__content",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm._f("dot")(_vm.countOrderMap[10])) + " "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _c("el-tab-pane", { attrs: { label: "加单", name: "12" } }, [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v("加单"),
                    ]),
                  ]),
                  _c("el-tab-pane", { attrs: { label: "已完成", name: "0" } }, [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v("已完成"),
                    ]),
                  ]),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "已取消", name: "13" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v("已取消"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "bcWhite box-shadow",
              staticStyle: { "margin-top": "10px" },
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "marginRight10",
                  attrs: {
                    filterable: "",
                    placeholder: "全部门店",
                    clearable: "",
                  },
                  on: { change: _vm.changeListData },
                  model: {
                    value: _vm.queryParams.cshop,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "cshop", $$v)
                    },
                    expression: "queryParams.cshop",
                  },
                },
                _vm._l(_vm.storeOptions, function (item) {
                  return _c("el-option", {
                    key: item.sid,
                    attrs: { label: item.cname, value: item.sid },
                  })
                }),
                1
              ),
              _c(
                "el-select",
                {
                  staticClass: "marginRight10",
                  attrs: { placeholder: "全部渠道", clearable: "" },
                  on: { change: _vm.changeListData },
                  model: {
                    value: _vm.queryParams.platType,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "platType", $$v)
                    },
                    expression: "queryParams.platType",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "美团", value: "1" } }),
                  _c("el-option", { attrs: { label: "饿了么", value: "2" } }),
                  _c("el-option", { attrs: { label: "京东", value: "3" } }),
                  _c("el-option", {
                    attrs: { label: "小程序商城", value: "4" },
                  }),
                ],
                1
              ),
              _c(
                "el-select",
                {
                  ref: "sortSelect",
                  staticClass: "marginRight10",
                  attrs: { placeholder: "排序方式", clearable: "" },
                  on: { change: _vm.handleSelectSort },
                  model: {
                    value: _vm.sortingValue,
                    callback: function ($$v) {
                      _vm.sortingValue = $$v
                    },
                    expression: "sortingValue",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "下单时间倒序", value: "s_order_time-0" },
                  }),
                  _c("el-option", {
                    attrs: { label: "下单时间正序", value: "s_order_time-1" },
                  }),
                  _c("el-option", {
                    attrs: { label: "抢单时间倒序", value: "s_receive_time-0" },
                  }),
                  _c("el-option", {
                    attrs: { label: "抢单时间正序", value: "s_receive_time-1" },
                  }),
                  _c("el-option", {
                    attrs: { label: "预计送达倒序", value: "s_wish_time-0" },
                  }),
                  _c("el-option", {
                    attrs: { label: "预计送达正序", value: "s_wish_time-1" },
                  }),
                ],
                1
              ),
              _c(
                "el-input",
                {
                  staticClass: "w300 marginLeftAuto",
                  attrs: { placeholder: "手机、姓名、地址、订单号、TOPS号" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.handleSelectSearch.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.queryParams.search,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "search", $$v)
                    },
                    expression: "queryParams.search",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-input__icon el-icon-search pointer",
                    attrs: { slot: "suffix" },
                    on: { click: _vm.handleSelectSearch },
                    slot: "suffix",
                  }),
                ]
              ),
              _c(
                "el-button",
                {
                  staticClass: "margin10",
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.openCreateOrderDialog },
                },
                [_vm._v("创建订单")]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          {
            staticClass: "right bcWhite box-shadow h100",
            staticStyle: { "min-width": "30%" },
          },
          [
            _vm.queryParams.zFlow === "0"
              ? _c(
                  "div",
                  {
                    staticClass: "hHP flex directionColumn contentCenter",
                    staticStyle: { "background-color": "rgb(235, 244, 246)" },
                  },
                  [
                    _c("div", { staticClass: "marginLeft20 marginBottom5" }, [
                      _vm._v("已完成"),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "marginLeft20 fs20 fWB",
                        staticStyle: { color: "rgb(0, 170, 48)" },
                      },
                      [_vm._v(_vm._s(_vm.countOrderMap[0]))]
                    ),
                  ]
                )
              : _vm._e(),
            !(_vm.queryParams.zFlow === "0")
              ? _c(
                  "div",
                  { staticClass: "hHP marginTop10 marginLeft20" },
                  [
                    _c(
                      "el-row",
                      {
                        staticClass: "marginBottom5",
                        staticStyle: { height: "23px" },
                      },
                      [
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "fs13 pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.handleTabClick({ name: "1" })
                                },
                              },
                            },
                            [_vm._v("新订单")]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c("div", { staticClass: "fs13" }, [
                            _vm._v(_vm._s(_vm.countOrderMap[1])),
                          ]),
                        ]),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "fs13 pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.handleTabClick({ name: "2" })
                                },
                              },
                            },
                            [_vm._v("异常订单")]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c("div", { staticClass: "fs13" }, [
                            _vm._v(_vm._s(_vm.countOrderMap[2])),
                          ]),
                        ]),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "fs13 pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.handleTabClick({ name: "3" })
                                },
                              },
                            },
                            [_vm._v("催单")]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c("div", { staticClass: "fs13" }, [
                            _vm._v(_vm._s(_vm.countOrderMap[3])),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      {
                        staticClass: "marginBottom5 h20",
                        staticStyle: { height: "23px" },
                      },
                      [
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "fs13 pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.handleTabClick({ name: "4" })
                                },
                              },
                            },
                            [_vm._v("配送异常")]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c("div", { staticClass: "fs13" }, [
                            _vm._v(_vm._s(_vm.countOrderMap[4])),
                          ]),
                        ]),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "fs13 pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.handleTabClick({ name: "5" })
                                },
                              },
                            },
                            [_vm._v("申请退款")]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c("div", { staticClass: "fs13" }, [
                            _vm._v(_vm._s(_vm.countOrderMap[5])),
                          ]),
                        ]),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "fs13 pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.handleTabClick({ name: "6" })
                                },
                              },
                            },
                            [_vm._v("预订单")]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c("div", { staticClass: "fs13" }, [
                            _vm._v(_vm._s(_vm.countOrderMap[6])),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "fs13 pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.handleTabClick({ name: "7" })
                                },
                              },
                            },
                            [_vm._v("待抢单")]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c("div", { staticClass: "fs13" }, [
                            _vm._v(_vm._s(_vm.countOrderMap[7])),
                          ]),
                        ]),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "fs13 pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.handleTabClick({ name: "8" })
                                },
                              },
                            },
                            [_vm._v("待取货")]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c("div", { staticClass: "fs13" }, [
                            _vm._v(_vm._s(_vm.countOrderMap[8])),
                          ]),
                        ]),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "fs13 pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.handleTabClick({ name: "9" })
                                },
                              },
                            },
                            [_vm._v("配送中")]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c("div", { staticClass: "fs13" }, [
                            _vm._v(_vm._s(_vm.countOrderMap[9])),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ]),
      _c("div", { staticClass: "orderProcessCol__body" }, [
        _c("div", { staticClass: "body" }, [
          _c("div", { staticClass: "body__left flex directionColumn" }, [
            _vm.queryParams.zFlow === "1" || _vm.queryParams.zFlow === "6"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "h50 marginBottom10 box-shadow bcWhite wHP flex alignItemsCenter paddingLeft20",
                  },
                  [
                    _c(
                      "div",
                      [
                        _vm._v(" 自动发单 "),
                        _c("el-switch", {
                          staticClass: "marginLeft20",
                          attrs: { "active-value": "1", "inactive-value": "0" },
                          on: { change: _vm.handleAutoSend },
                          model: {
                            value: _vm.autoSend,
                            callback: function ($$v) {
                              _vm.autoSend = $$v
                            },
                            expression: "autoSend",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "marginLeft20" },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "marginRight10",
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: "请选择发单频次",
                            },
                            model: {
                              value: _vm.orderFrequency,
                              callback: function ($$v) {
                                _vm.orderFrequency = $$v
                              },
                              expression: "orderFrequency",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "每次20单", value: "20" },
                            }),
                            _c("el-option", {
                              attrs: { label: "每次30单", value: "30" },
                            }),
                            _c("el-option", {
                              attrs: { label: "每次50单", value: "50" },
                            }),
                            _c("el-option", {
                              attrs: { label: "每次100单", value: "100" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "flex1 scrollAuto scrollbar" }, [
              _c(
                "div",
                { staticClass: "hHP" },
                [
                  _c("OrderList", {
                    ref: "orderList",
                    staticClass: "hHP",
                    on: { changeListInfoData: _vm.changeListInfoData },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "body__right" },
            [
              _c("OrderListInfo", {
                ref: "orderListInfo",
                staticClass: "bcWhite box-shadow",
                on: { changeListData: _vm.changeListData },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "el-dialog",
        {
          staticStyle: { top: "-10vh" },
          attrs: {
            "close-on-click-modal": false,
            title: "创建订单",
            visible: _vm.createOrderdialogVisible,
            width: "1300px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.createOrderdialogVisible = $event
            },
          },
        },
        [
          _vm.createOrderdialogVisible
            ? _c("OrderCreateInfo", {
                ref: "orderInfo",
                on: { "close-dialog": _vm.closeCreateOrderDialog },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }